import { combineReducers } from 'redux';
import main from './main';

const rootReducer = combineReducers({
  main
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/rootReducer.js